import React from 'react'
import styled from 'styled-components'

const Ingredientstyle = styled.div`
    padding: 30px 0 50px 0;
    .ingredients {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 20px;
      
      .nutritional-needs {
        width: 100%;
        justify-content: space-evenly;
        max-width: 610px;

        ul {
          li {
            list-style: none;
            font-size: 32px;
            color: #000;
            @media (max-width: 991px){
                font-size:28px;
            }
            @media (max-width: 767px){
                font-size:24px;
            }
          }
        }
        p {
          border: 2px solid var(--green);
        }
      }
      .ingredient-list-button {
        button {
          padding: 8px 30px;
          font-size: 24px;
          border-radius: 30px;
          color: #fff;
          background: var(--green);
          font-weight: 600;
          margin: 0;
          line-height: 33px;
        }
      }
    }
`
export default Ingredientstyle